import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import MenuList from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import withStyles from "@material-ui/core/styles/withStyles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { instance } from "Actions/AxiosInstance";
import { GetFeature } from "Actions/commonAction";
import downloadIcon from "Assets/newicons/action/download/outline/download-outline-16px.svg";
import uploadIcon from "Assets/newicons/action/upload/outline/upload-outline-16px.svg";
import PageHeader from "Component/Headers/pageHeader";
import IconWithBackground from "Component/Icons/iconWithBackground";
import SearchRound from "Component/Material-ui/SearchRound";
import ProfilePictureSmall from "Component/Thumbnail/ProfilePictureSmall";
import { ErrorMessages } from "Constants";
import * as FileSaver from "file-saver";
import get from "lodash/get";
import moment from "moment";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import readXlsxFile from "read-excel-file";
import { getFormattedImageLink, getMonthName } from "Utils";
import { getDisplayNameFromArray, getDisplayValueFromArray } from "Utils/arr";
import * as XLSX from "xlsx";

const TEMP = [
  {
    employeename: "Name",
    primarymobile: "Mobile",
    remark: "Remarks",
    paymentamount: "Amount",
    salarycomponentidname: "Salary component",
  },
  {
    employeename: "Name 1",
    primarymobile: "Mobile",
    remark: "Remarks",
    paymentamount: "Amount",
    salarycomponentidname: "Salary component",
  },
  {
    employeename: "Name 2",
    primarymobile: "Mobile",
    remark: "Remarks",
    paymentamount: "Amount",
    salarycomponentidname: "Salary component",
  },
  // {
  //   primarymobile: 89485948,
  //   lop_3: null,
  //   loparreares_3: null,
  //   lop_2: null,
  //   loparreares_2: null,
  //   lop_1: null,
  //   loparreares_1: null,
  // },
];

export const ExportArrearsXLSX = (props = {}) => {
  const { rows = TEMP, monthid = 4, year = 2019, date = "" } = props;
  // const initdate = moment(`${year}-${monthid - 1}-01`, "YYYY-MM-DD");
  // const thismonthid = initdate.format("m");
  // const _thismonthid = initdate.subtract("months", 1).format("m");
  // const __thismonthid = initdate.subtract("months", 2).format("m");

  // const headernames = [
  //   "Name",
  //   "Mobile",
  //   `LOP ${getMonthName(__thismonthid + 1)}`,
  //   `LOP Arrears ${getMonthName(__thismonthid + 1)}`,
  //   `LOP ${getMonthName(_thismonthid + 1)}`,
  //   `LOP Arrears ${getMonthName(_thismonthid + 1)}`,
  //   `LOP ${getMonthName(thismonthid + 1)}`,
  //   `LOP Arrears ${getMonthName(thismonthid + 1)}`,
  // ];

  const filename = `extrapayments${moment(date, "YYYY-MM-DD").format(
    "MMMM Do YYYY-h:mm:ss-a",
  )}.xlsx`;
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const ws = XLSX.utils.json_to_sheet([...rows], {
    header: [
      "empfullname",
      "department",
      "designation",
      "businessunit",
      "paymentname",
      "remark",
      "totalamount",
    ],
    skipHeader: true,
  });
  /* hide employeeid column */
  ws["!cols"] = [];
  ws["!cols"][7] = { hidden: true };
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, filename);
};

const styles = () => ({
  drawerPaper: {
    width: 356,
  },
});

const VIEWFIELDS = [];

const EXCELCONST = [];

const sortOptinos = [
  {
    displayname: "Name",
    displayvalue: 1,
  },
  {
    displayname: "Annual package",
    displayvalue: 2,
  },
  {
    displayname: "Gross",
    displayvalue: 3,
  },
];

const IMPACTESIC = [
  {
    displayname: "Yes",
    displayvalue: 1,
  },
  {
    displayname: "No",
    displayvalue: 2,
  },
];

class SalarySheet extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 1,
      fromdate: "",
      selectedEmployee: null,
      List: [],
      filterList: [],
      isdisable: true,
      employeelist: [],
      allsalarycomponents: [],
      loading: true,
      time: 0,
      time1: 0,
      isloading: false,
    };
    this.getdata = this.getdata.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  componentDidMount() {
    // ExportArrearsXLSX();
    this.getdata();
    instance
      .post("payroll/getallsalarycomponent", {
        componenttypeids: [1],
        isextrapayment: true,
      })
      .then((resp) => {
        if (get(resp, "data.result", []).length > 0) {
          this.setState({ allsalarycomponents: get(resp, "data.result", []) });
        } else {
          this.props.enqueueSnackbar(
            "Please create at least one extra payment / extra deduction component",
            { variant: "error" },
          );
        }
      });
  }

  showLoader() {
    return (
      <div
        className="pre-loader"
        style={{
          marginLeft: "50%",
          transform: "translateX(-50%)",
        }}
      >
        Loading...
      </div>
    );
  }

  getdata() {
    const { salarycycle, isSpeicalCase, specialEmps, normalEmps } = this.props;
    const disbursementmonthid = get(salarycycle, "payrollmonthid", 12);
    const disbursementyear = get(salarycycle, "payrollyear", 2019);
    const getTotal = (arr, employeeid) => {
      const result = arr.find((x) => x.employeeid == employeeid);
      return result ? result.totalamount : 0;
    };

    const getextrapayment = (arr, employeeid) => {
      const result = arr.find((x) => x.employeeid == employeeid);
      return result ? result.extrapayment : [];
    };
    const postdata = {
      monthid: disbursementmonthid,
      disbursementyear,
      employeeids: isSpeicalCase
        ? specialEmps.map((x) => x.employeeid)
        : normalEmps.map((x) => x.employeeid),
    };
    const totalseconds =
      postdata && postdata.employeeids && postdata.employeeids.length;
    const secondsforintervals = totalseconds * 1000;

    this.interval = setInterval(
      () =>
        this.setState({
          time: this.state.time >= 99 ? 99 : this.state.time + 1,
        }),
      secondsforintervals / 100,
    );
    instance
      .post("payroll/getemployeesextrapayment", postdata)
      .then((resp1) => {
        const data = isSpeicalCase
          ? specialEmps.map((x) => ({
              ...x,
              totalamount: getTotal(
                get(resp1, "data.result", []),
                x.employeeid,
              ),
              extrapayment: getextrapayment(
                get(resp1, "data.result", []),
                x.employeeid,
              ),
            }))
          : normalEmps.map((x) => ({
              ...x,
              totalamount: getTotal(
                get(resp1, "data.result", []),
                x.employeeid,
              ),
              extrapayment: getextrapayment(
                get(resp1, "data.result", []),
                x.employeeid,
              ),
            }));
        clearInterval(this.interval);
        this.setState({
          List: data,
          employeelist: !isSpeicalCase ? normalEmps : specialEmps,
          filterList: data,
          loading: false,
          time: 100,
        });
      })
      .catch((error) => {
        clearInterval(this.interval);
        this.setState({
          loading: false,
          time: 100,
        });
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  async uploadData(e) {
    const { List, allsalarycomponents } = this.state;
    const _file = e.target.files[0];
    if (!_file) {
      return;
    }
    const imgname = _file.name;
    let idxDot = "";
    let extFile = "";
    idxDot = imgname.lastIndexOf(".") + 1;
    extFile = imgname.substr(idxDot, imgname.length).toLowerCase();
    if (extFile != "xlsx") {
      this.props.enqueueSnackbar("Please select valid file format", {
        variant: "error",
      });
      return;
    }
    try {
      let rows = await readXlsxFile(_file);
      console.log("rows11: ", rows);
      rows = rows
        ? rows.filter(
            (x, i) => i > 0 && x[4] && x[5] && x[6] && x[7] && x[10] && x[11],
          )
        : [];
      if (rows && rows[0]) {
        // rows = rows.slice(3, 4);
        console.log("rows: ", rows);
        const result = [...List].map((x) => {
          const thisinput = rows.find((row) => x.employeeid == row[13]) || [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
          ];
          console.log("thisinput: ", thisinput);
          return {
            ...x,
            paymentname: thisinput[4],
            remark: thisinput[7],
            totalamount: thisinput[5] || x.totalamount,
            salarycomponentid: getDisplayValueFromArray(
              thisinput[6],
              allsalarycomponents,
            ),
            updatedfromexcel: thisinput[5] ? true : false,
            isimpactgovstatutory:
              getDisplayNameFromArray(thisinput[10], IMPACTESIC) == "Yes" ||
              getDisplayNameFromArray(thisinput[11], IMPACTESIC) == "Yes"
                ? true
                : false,
            govstatutoryids:
              getDisplayNameFromArray(thisinput[10], IMPACTESIC) == "Yes" &&
              getDisplayNameFromArray(thisinput[11], IMPACTESIC) == "Yes"
                ? "7,5"
                : getDisplayNameFromArray(thisinput[10], IMPACTESIC) == "Yes"
                ? "7"
                : getDisplayNameFromArray(thisinput[11], IMPACTESIC) == "Yes"
                ? "5"
                : null,
          };
        });
        this.setState({ List: result, isdisable: false });
      } else {
      //  this.props.enqueueSnackbar(ErrorMessages.E0070, { variant: "error" });
      this.props.enqueueSnackbar("Please fill all fields of excel sheet", {
        variant: "error",
      });
      }
    } catch (error) {
      this.props.enqueueSnackbar(ErrorMessages.E0070, { variant: "error" });
    }
  }

  onSave() {
    const { salarycycle = null } = this.props;
    const { List } = this.state;
    const disbursementmonthid = get(salarycycle, "payrollmonthid", 12);
    const disbursementyear = get(salarycycle, "payrollyear", 2019);
    // const mastergroupheaedid = this.state.allsalarycomponents.filter(x => x.)

    const extrapayments = [...List]
      .filter((x) => x.updatedfromexcel)
      .map((x) => ({
        empextrapaymentid: null,
        employeeid: x.employeeid,
        paymentname: x.paymentname,
        paymentamount: x.totalamount,
        disbursementmonthid,
        disbursementyear,
        salarycomponentid: x.salarycomponentid, // x.salarycomponentid
        sourceid: 3,
        // mastertaxgroupid: null,
        remark: x.remark,
        isimpactgovstatutory: x.isimpactgovstatutory,
        govstatutoryids: x.govstatutoryids,
        // mastertaxgroupid: x.mastertaxgroupid || null,
        mastertaxgroupid:
          this.state.allsalarycomponents.find(
            (x1) => x1.displayvalue == x.salarycomponentid,
          ).mastertaxgroupid || null,
        taxgroupheadid:
          this.state.allsalarycomponents.find(
            (x1) => x1.displayvalue == x.salarycomponentid,
          ).taxgroupheadid || null,
      }));
    const { issaveinprogress } = this.props.SaveInProgressReducer;
    console.log("issaveinprogress: ", issaveinprogress);
    if (!issaveinprogress) {
      this.props.setSaveProgress(true);
      const totalseconds = extrapayments.length * 3;
      const secondsforintervals = totalseconds * 1000;
      this.interval = setInterval(
        () =>
          this.setState({
            time1: this.state.time1 >= 99 ? 99 : this.state.time1 + 1,
          }),
        secondsforintervals / 100,
      );

      this.setState(
        {
          // time1: 0,
          isloading: true,
        },
        () => {
          instance
            .post("payroll/bulkuploadextrapayment", { extrapayments })
            .then(() => {
              this.props.removeSaveProgress();
              this.props.enqueueSnackbar("Uploaded successfully", {
                variant: "success",
              });
              this.setState({
                time1: 100,
                isloading: false,
              });
              this.getdata();
            })
            .catch((error) => {
              this.props.removeSaveProgress();
              this.setState({
                time1: 100,
                isloading: false,
              });
              this.props.enqueueSnackbar(
                error.response
                  ? error.response.data.error.message
                  : error.message,
                { variant: "error" },
              );
            });
        },
      );
    }
  }

  handleSearch = (e) => {
    const { List, filterList } = this.state;
    const ff = List.filter(
      (item) =>
        item.empfullname.toLowerCase().search(e.target.value.toLowerCase()) !==
        -1,
    );
    this.setState({
      searchValue: e.target.value,
      List: e.target.value ? ff : filterList,
    });
  };

  ExportData = () => {
    // const { List = [] } = this.state;
    const { salarycycle } = this.props;
    const { employeelist } = this.state;
    // const unassignedemployees = List.filter(
    //   (x) => !x.totalamount || x.totalamount == 0,
    // );
    // const headerobj = {
    //   empfullname: "Name",
    //   department: "Department",
    //   designation: "Designation",
    //   businessunit: "Location",
    //   totalamount: "Extra payment",
    //   remark: "Remark",
    //   paymentname: "Payment name",
    // };
    // ExportArrearsXLSX({
    //   rows: [
    //     headerobj,
    //     ...unassignedemployees.map((x) => ({
    //       empfullname: x.empfullname || null,
    //       department: x.department || null,
    //       designation: x.designation || null,
    //       businessunit: x.businessunit || null,
    //       totalamount: x.totalamount || null,
    //       remark: x.remark || null,
    //       paymentname: x.paymentname || null,
    //       // salarycomponentid
    //       employeeid: x.employeeid,
    //     })),
    //   ],
    //   date: salarycycle ? salarycycle.cycleto : moment(new Date()).format("YYYY-MM-DD"),
    // });
    const date = salarycycle
      ? salarycycle.cycleto
      : moment(new Date()).format("YYYY-MM-DD");
    const feature = GetFeature("runpayroll");
    const name = salarycycle && salarycycle.displayname;
    const filename = `Extra_Payment_${getMonthName(name.split("-")[0])}_${
      name.split("-")[1]
    }.xlsx`;
    if (feature) {
      if (this.state.allsalarycomponents.length > 0) {
        instance
          .get(
            `/payroll/getxlsforempextrapayment/null/null/null/null/null/null/${employeelist
              .map((x) => x.employeeid)
              .join(",")}/true/${feature.profilemenuactionid}`,
            { responseType: "blob" },
          )
          .then((result) => {
            const url = window.URL.createObjectURL(new Blob([result.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
          });
      } else {
        this.props.enqueueSnackbar(
          "Please create at least one extra payment component ",
          { variant: "error" },
        );
      }
    }
  };

  render() {
    const { classes } = this.props;
    const {
      selectedEmployee,
      searchValue,
      List = [],
      allsalarycomponents = [],
    } = this.state;
    // const List = searchValue ? filterList : salarysheet;
    const { setsalaryadjustpage } = this.props;

    return (
      // <div>
      // {(this.state.loading == true) ? (
      //   this.showLoader()
      // )
      //   :
      <div className="innerwrapper-full-width">
        <div className="margin-top-4">
          <PageHeader header="3.2 File extra payments" />
        </div>
        <Grid container>
          <Grid item xs={12} md={8} sm={12}>
            {/* <PageHeader header={"Step 3a: File arrears and LOP"} /> */}
            <div className="floatleft margin-right-8">
              <SearchRound
                placeholder="Search employee"
                value={searchValue}
                onChange={this.handleSearch}
              />
            </div>
            {/* <div className="margin-right-8 floatleft">
              <IconWithBackground imgsrc={filterIcon} />
            </div>
            <div className="margin-right-8 floatleft">
              <IconWithBackground imgsrc={settingIcon} />
            </div> */}
            {allsalarycomponents.length > 0 && (
              <div
                className="margin-right-8 floatleft cursour-pointer"
                onClick={this.ExportData}
              >
                <IconWithBackground imgsrc={downloadIcon} />
              </div>
            )}
            {allsalarycomponents.length > 0 && (
              <div
                className="margin-right-8 floatleft cursour-pointer"
                onClick={() => {
                  document.getElementById("fileupload").click();
                }}
              >
                <input
                  id="fileupload"
                  type="file"
                  name="Upload Emploxyee Data"
                  onChange={(e) => this.uploadData(e)}
                  hidden
                />
                <IconWithBackground imgsrc={uploadIcon} />
              </div>
            )}
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
            sm={4}
            style={{
              justifyContent: "flex-end",
              display: "flex",
              marginTop: 16,
            }}
          >
            {/* <div
              className="sort-data floatleft"
              buttonRef={(node1) => {
                this.anchorEl = node1;
              }}
              onClick={this.onSortMenuClick}
            >
              <div>
                <span className="t-14 t-bold">None</span>
              </div>
            </div> */}
            {/*
            <div className="sort-arrow floatleft">
              {this.state.sortorder == 1 && (
                <img
                  src={upArrow}
                  className="margin-top-4"
                  onClick={() => this.setSortByOrder(2)}
                ></img>
              )}
              {this.state.sortorder == 2 && (
                <img
                  src={downArrow}
                  className="margin-top-4"
                  onClick={() => this.setSortByOrder(1)}
                ></img>
              )}
            </div> */}

            <Popover
              open={this.state.sortmenu}
              anchorEl={this.state.sort_anchorEl}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              onClose={this.sortMenuClose}
              className="margin-top-8"
            >
              <Paper style={{ width: 140 }}>
                <div>
                  <MenuList>
                    {sortOptinos.map((option) => (
                      <ListItem
                        className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                        onClick={() => this.setSortName(option.displayvalue)}
                      >
                        <ListItemText style={{ padding: 0 }}>
                          <span className="small-dark-secondary">
                            {option.displayname}
                          </span>
                        </ListItemText>
                      </ListItem>
                    ))}
                  </MenuList>
                </div>
              </Paper>
            </Popover>
          </Grid>
        </Grid>
        <Grid container spacing={3} className="margin-top-8 padding-bottom-90">
          <Grid item xs={12} md={8} sm={12} style={{ overflowX: "hidden" }}>
            <Table
              className="payroll-data-table"
              size="small"
              aria-label="a dense table"
            >
              <TableHead className={classes.tablehead}>
                <TableRow style={{ height: 44 }}>
                  {/* <TableCell>Name</TableCell> */}
                  <TableCell style={{ width: 81 }} align="left">
                    Employee ID
                  </TableCell>
                  <TableCell align="left">Name</TableCell>
                  <TableCell align="right">Deparment</TableCell>
                  <TableCell align="right">Designation</TableCell>
                  <TableCell align="right">Location</TableCell>
                  <TableCell align="right">Total extra payment</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {List.map((row) => (
                  <TableRow
                    key={row.empsalarysheetid}
                    onClick={() => this.setState({ selectedEmployee: row })}
                    className={`t-12 cursour-pointer ${
                      row.employeeid ==
                        get(selectedEmployee, "employeeid", "") &&
                      "bg-color-f7f8f8"
                    }`}
                  >
                    {/* <TableCell>
                      <div
                        className="floatleft margin-right-8"
                        style={{ height: 32 }}
                      >
                        <ProfilePictureSmall
                          src={getFormattedImageLink(row.imagepath)}
                        />
                      </div>
                      <div className="floatleft margin-top-8 width70">
                        <p className="small-dark-secondary ellipsis">
                          {row.fullname}
                        </p>
                      </div>
                    </TableCell> */}
                    <TableCell align="left">{row.employeecode}</TableCell>

                    <TableCell align="left">{row.empfullname}</TableCell>
                    <TableCell align="right">{row.department}</TableCell>
                    <TableCell align="right">{row.designation}</TableCell>
                    <TableCell align="right">{row.businessunit}</TableCell>
                    <TableCell align="right">{row.totalamount}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Grid>
          <Grid item xs={12} md={4} sm={12}>
            <Paper
              className="additional-details-wrapper rounded-rectangle-paper thin-scroll"
              style={{ height: 310 }}
            >
              <div style={{ background: "#edf5fd", padding: "8px" }}>
                <p className="small-dark-secondary t-bold text-align-center">
                  Additional details
                </p>
              </div>
              {selectedEmployee ? (
                <div className="padding16">
                  <div>
                    <div
                      className="floatleft margin-right-8"
                      style={{ height: 32 }}
                    >
                      <ProfilePictureSmall
                        src={getFormattedImageLink(selectedEmployee.imagepath)}
                      />
                    </div>
                    <div className="floatleft margin-top-8 width70">
                      <p className="small-dark-secondary ellipsis">
                        {selectedEmployee.empfullname}
                      </p>
                    </div>
                    <div className="clear-float"></div>
                  </div>
                  {selectedEmployee.extrapayment &&
                  selectedEmployee.extrapayment[0] ? (
                    <div className="margin-bottom-16">
                      {selectedEmployee.extrapayment.map((x) => (
                        <div key={x.disbursementmonthid}>
                          <div className="margin-top-16">
                            <p className="input-label">Payment name</p>
                            <div className="data-div-disabled">
                              <p className="small-dark-disabled">
                                {x.paymentname || "-"}
                              </p>
                            </div>
                          </div>

                          <div className="margin-top-16">
                            <p className="input-label">Pending amount</p>
                            <div className="data-div-disabled">
                              <p className="small-dark-disabled">
                                {x.pendingamount || "-"}
                              </p>
                            </div>
                          </div>

                          <div className="margin-top-16">
                            <p className="input-label">Disbursement month</p>
                            <div className="data-div-disabled">
                              <p className="small-dark-disabled">
                                {getMonthName(x.disbursementmonthid) || "-"}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="margin-bottom-16">
                      <div>
                        <div className="margin-top-16">
                          <p className="input-label">Payment name</p>
                          <div className="data-div-disabled">
                            <p className="small-dark-disabled">
                              {selectedEmployee.paymentname || "-"}
                            </p>
                          </div>
                        </div>

                        <div className="margin-top-16">
                          <p className="input-label">Pending amount</p>
                          <div className="data-div-disabled">
                            <p className="small-dark-disabled">
                              {selectedEmployee.totalamount || "-"}
                            </p>
                          </div>
                        </div>

                        {/* <div className="margin-top-16">
                            <p className="input-label">Disbursement month</p>
                            <div className="data-div-disabled">
                              <p className="small-dark-disabled">
                                {selectedEmployee.disbursementmonthyear}
                              </p>
                            </div>
                          </div> */}
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="padding16">
                  <p className="input-label text-align-center">
                    No employee selected
                  </p>
                </div>
              )}
            </Paper>
          </Grid>
        </Grid>

        <div className="width100">
          <div>
            <div className="floatleft" style={{ marginLeft: 172 }}>
              <div
                className="width100"
                style={{
                  position: "fixed",
                  left: 0,
                  background: "white",
                  bottom: 0,
                  padding: 10,
                  borderTop: "1px solid #d4d4d4",
                  zIndex: 0,
                }}
              >
                <div>
                  <div className="floatleft" style={{ marginLeft: 172 }}>
                    <Button
                      className="btn btn-secondary-md-blue margin-right-16"
                      variant="contained"
                      onClick={() => setsalaryadjustpage("home")}
                    >
                      Go back
                    </Button>
                  </div>
                  <div className="floatright" style={{ marginRight: 72 }}>
                    <div>
                      <Button
                        className="btn btn-primary-md-blue"
                        variant="contained"
                        onClick={this.onSave}
                        disabled={
                          this.props.SaveInProgressReducer.issaveinprogress ||
                          this.state.isdisable
                        }
                        // onClick={this.analysedData()}
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                  <div className="clearfloat"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Dialog
          fullWidth={true}
          maxWidth="sm"
          open={this.state.loading}
          // onClose={() => this.setState({ openDialog: false, empform1: null })}
          aria-labelledby="max-width-dialog-title"
          classes={{
            scrollPaper: "no-shadow bg-transparent",
            paper: "no-shadow bg-transparent",
          }}
        >
          <DialogContent>
            <div
              className="progess-wrapper"
              style={{
                position: "relative",
                width: 120,
                height: 120,
                margin: "0 auto",
                color: "#fff",
              }}
            >
              <CircularProgress
                className="goal-progress"
                variant="static"
                value={this.state.time}
                color="inherit"
              />
              <div
                className="progress-line"
                style={{ borderColor: "#fff" }}
              ></div>
              <div
                className="vertical-center text-center"
                style={{ height: 30 }}
              >
                <span
                  style={{
                    display: "block",
                    fontSize: 24,
                    color: "#fff",
                    fontWeight: "bold",
                  }}
                >
                  {this.state.time}%
                </span>
              </div>
            </div>
          </DialogContent>
        </Dialog>
        <Dialog
          fullWidth={true}
          maxWidth="sm"
          open={this.state.isloading}
          // onClose={() => this.setState({ openDialog: false, empform1: null })}
          aria-labelledby="max-width-dialog-title"
          classes={{
            scrollPaper: "no-shadow bg-transparent",
            paper: "no-shadow bg-transparent",
          }}
        >
          <DialogContent>
            <div
              className="progess-wrapper"
              style={{
                position: "relative",
                width: 120,
                height: 120,
                margin: "0 auto",
                color: "#fff",
              }}
            >
              <CircularProgress
                className="goal-progress"
                variant="static"
                value={this.state.time1}
                color="inherit"
              />
              <div
                className="progress-line"
                style={{ borderColor: "#fff" }}
              ></div>
              <div
                className="vertical-center text-center"
                style={{ height: 30 }}
              >
                <span
                  style={{
                    display: "block",
                    fontSize: 24,
                    color: "#fff",
                    fontWeight: "bold",
                  }}
                >
                  {this.state.time1}%
                </span>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
      // }
      // </div>
    );
  }
}

export default connect()(
  withStyles(styles, { withTheme: true })(withSnackbar(SalarySheet)),
);
